var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__produkty"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4458",
    x: 3,
    y: 4,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4459",
    x: 9,
    y: 4,
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4460",
    x: 3,
    y: 10,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4461",
    x: 9,
    y: 10,
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4462",
    x: 3,
    y: 16,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4463",
    x: 9,
    y: 16,
    width: 12,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.000fb69e9358dc5004b396b4f3546557.svg";
export { ForwardRef as ReactComponent };